<template>
  <section class="home-block">
    <div class="content">
      <div class="container">
        <div ref="title" class="title">
          <slot name="title">
            <h2>Генплан</h2>
          </slot>
        </div>
      </div>
    </div>
    <Buildings />
  </section>
</template>

<script>
import Buildings from "@/components/planArchive/Buildings.vue";
import { gsap } from "gsap";
import { is_touch } from "@/helpers.js";
export default {
  components: {
    Buildings,
  },
  data() {
    return {};
  },
  mounted() {
    if (!is_touch()) {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: this.$el,
            start: "top bottom",
            end: "280px center",
            scrub: 1.5,
          },
        })
        .from(
          gsap.utils.toArray([this.$refs.title, this.$refs.btn]),
          {
            y: 100,
            stagger: { each: 0.1 },
          },
          0
        );
    }
  },
};
</script>

<style scoped>
.title {
  text-align: center;
}

h2 {
  color: #545863;
}

@media (max-width: 575px) {
  h2 {
    font-size: 36px;
  }
}
</style>
